import { render } from "./TailingwasteManagement.vue?vue&type=template&id=00c81e7e&scoped=true"
import script from "./TailingwasteManagement.vue?vue&type=script&lang=js"
export * from "./TailingwasteManagement.vue?vue&type=script&lang=js"

import "./TailingwasteManagement.vue?vue&type=style&index=0&id=00c81e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c81e7e"]])

export default __exports__